import { render } from "./TranslationsMenu.vue?vue&type=template&id=18bbff3d"
const script = {}

import "./TranslationsMenu.vue?vue&type=style&index=0&id=18bbff3d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__